import { render, staticRenderFns } from "./companyWallet.vue?vue&type=template&id=21cabf46&"
import script from "./companyWallet.vue?vue&type=script&lang=js&"
export * from "./companyWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports